import React from 'react'
import { SectionList } from './list/page'

export const SectionPage = () => <SectionList />
